<template>
  <page-content id="test-users-combo-view">
    <v-card class="mb-4">
      <v-card-title>UsersCombo — Test View</v-card-title>
      <v-card-text>
        <p class="grey--text">Interaktywne testowanie wszystkich wariantów komponentu UsersCombo.</p>
        <p class="grey--text caption">Testy: wpisz tekst → wyjdź z pola (blur) → sprawdź czy "ghost value" jest czyszczony</p>
      </v-card-text>
    </v-card>

    <v-row>
      <!-- 1. Single, no avatar, allowNew=true -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">1. Single + No Avatar + Allow New</v-card-title>
          <v-card-subtitle>Wpisz coś i wyjdź z pola - sprawdź ghost value</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant1Selected"
              @user-selected="variant1Selected = $event"
              :users="mockUsersPromise"
              label="Wybierz użytkownika"
              hint="Możesz wpisać nową wartość"
              :multiple="false"
              :allow-new="true"
              :avatar="false"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected:</strong> {{ variant1Selected | userName }}</small>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 2. Single, avatar, allowNew=false -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">2. Single + Avatar + Allow New: False</v-card-title>
          <v-card-subtitle>Patrol wybór - nie możesz wpisać nowych wartości</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant2Selected"
              @user-selected="variant2Selected = $event"
              :users="mockUsersPromise"
              label="Wybierz patrol"
              hint="Tylko z listy"
              :multiple="false"
              :allow-new="false"
              :avatar="true"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected:</strong> {{ variant2Selected | userName }}</small>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 3. Multiple, chips, no avatar -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">3. Multiple + Chips + No Avatar</v-card-title>
          <v-card-subtitle>Wybierz kilka pracowników</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant3Selected"
              @user-selected="variant3Selected = $event"
              :users="mockUsersPromise"
              label="Wybierz pracowników"
              :multiple="true"
              :allow-new="true"
              :avatar="false"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected ({{ variant3Selected.length }}):</strong></small>
              <div v-for="(user, i) in variant3Selected" :key="i" class="caption">
                • {{ user | userName }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 4. Multiple, avatar, allowNew=false -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">4. Multiple + Avatar + Allow New: False</v-card-title>
          <v-card-subtitle>Zaproszenia do witryny - z avatarami</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant4Selected"
              @user-selected="variant4Selected = $event"
              :users="mockUsersPromise"
              label="Zaproś członków"
              hint="Wybierz spośród istniejących"
              :multiple="true"
              :allow-new="false"
              :avatar="true"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected ({{ variant4Selected.length }}):</strong></small>
              <div v-for="(user, i) in variant4Selected" :key="i" class="caption">
                • {{ user | userName }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 5. Single, async Function source -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">5. Single + Function Source (Async Search)</v-card-title>
          <v-card-subtitle>Wpisz aby filtrować na serwerze - no avatar, allow-new=false</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant5Selected"
              @user-selected="variant5Selected = $event"
              :users="mockUsersFunction"
              label="Wyszukaj użytkownika"
              hint="Wpisz aby wyszukać..."
              :multiple="false"
              :allow-new="false"
              :avatar="false"
              :search-input.sync="variant5Search"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected:</strong> {{ variant5Selected | userName }}</small>
              <div class="caption grey--text">Search: "{{ variant5Search }}"</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 6. Multiple, async Function source with avatar -->
      <v-col cols="12" md="6">
        <v-card class="mb-4">
          <v-card-title class="subtitle-2">6. Multiple + Function Source + Avatar</v-card-title>
          <v-card-subtitle>Kilka wyborów z async search i avatarami</v-card-subtitle>
          <v-card-text>
            <users-combo
              :usersSelected="variant6Selected"
              @user-selected="variant6Selected = $event"
              :users="mockUsersFunction"
              label="Wyszukaj dyspozytorów"
              hint="Wpisz aby wyszukać..."
              :multiple="true"
              :allow-new="false"
              :avatar="true"
              :search-input.sync="variant6Search"
            />
            <div class="mt-3 pa-2 surface lighten-1 rounded">
              <small><strong>Selected ({{ variant6Selected.length }}):</strong></small>
              <div v-for="(user, i) in variant6Selected" :key="i" class="caption">
                • {{ user | userName }}
              </div>
              <div class="caption grey--text mt-1">Search: "{{ variant6Search }}"</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </page-content>
</template>

<script>
export default {
  name: "TestUsersCombo",

  data: () => ({
    variant1Selected: null,
    variant2Selected: null,
    variant3Selected: [],
    variant4Selected: [],
    variant5Selected: null,
    variant5Search: undefined,
    variant6Selected: [],
    variant6Search: undefined,

    mockUsers: [
      {
        id: 1,
        full_name: "Jan Kowalski",
        first_name: "Jan",
        last_name: "Kowalski",
        username: "jkowalski",
        email: "jan@example.com",
        avatar_url: null,
        job_title: "Dyspozytor",
        organization: "Patrol",
        tags: [
          { title: "Admin", color: "primary" }
        ]
      },
      {
        id: 2,
        full_name: "Maria Nowak",
        first_name: "Maria",
        last_name: "Nowak",
        username: "mnowak",
        email: "maria@example.com",
        avatar_url: "https://ui-avatars.com/api/?name=Maria+Nowak&background=green&color=fff&bold=true",
        job_title: "Kierowca",
        organization: "Vozilo Beta",
        tags: [
          { title: "Patrol", color: "success" }
        ]
      },
      {
        id: 3,
        full_name: "Piotr Zieliński",
        first_name: "Piotr",
        last_name: "Zieliński",
        username: "pzielinski",
        email: "piotr@example.com",
        avatar_url: "https://ui-avatars.com/api/?name=Piotr+Zielinski&background=orange&color=fff&bold=true",
        job_title: "Inspektor",
        organization: "Główna",
        tags: [
          { title: "Kierownik", color: "orange" }
        ]
      },
      {
        id: 4,
        full_name: "Anna Lewandowska",
        first_name: "Anna",
        last_name: "Lewandowska",
        username: "alewandowska",
        email: "anna@example.com",
        avatar_url: "https://ui-avatars.com/api/?name=Anna+Lewandowska&background=purple&color=fff&bold=true",
        job_title: "Operator",
        organization: "Centrum",
        tags: []
      },
      {
        id: 5,
        full_name: "Tomasz Wójcik",
        first_name: "Tomasz",
        last_name: "Wójcik",
        username: "twojcik",
        email: "tomasz@example.com",
        avatar_url: "https://ui-avatars.com/api/?name=Tomasz+Wojcik&background=red&color=fff&bold=true",
        job_title: "Technik",
        organization: "Wsparcie",
        tags: [
          { title: "Dostęp globalny", color: "success" }
        ]
      }
    ],
    mockUsersPromise: null
  }),

  beforeMount() {
    this.mockUsersPromise = new Promise((resolve) => {
      setTimeout(() => resolve(this.mockUsers), 300)
    })
  },

  methods: {
    mockUsersFunction(searchValue) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const filtered = this.mockUsers.filter(user =>
            !searchValue ||
            user.full_name.toLowerCase().includes(searchValue.toLowerCase()) ||
            user.username.toLowerCase().includes(searchValue.toLowerCase())
          )
          resolve(filtered)
        }, 200)
      })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
